import { FC } from "react";
import BatteryIcon from "shared/ui/icons/batteryIcon";
import { DevicesColPin } from "./styles";

type Props = { voltage: number | null };

const resolveColors = (v: number) => {
    if (v < 1.0) {
        return {
            color: "var(--error-on-container, rgba(255, 38, 38, 1))",
            bg: "var(--error-container-default, rgba(255, 38, 38, 0.1))",
        };
    }
    if (v < 2.5) {
        return {
            color: "var(--warning-on-container, rgba(215, 141, 14, 1))",
            bg: "var(--warning-container-default, rgba(253, 166, 16, 0.1))",
        };
    }
    return {
        color: "var(--success-default, rgba(10, 203, 91, 1))",
        bg: "var(--success-container-default, rgba(10, 203, 91, 0.1))",
    };
};

export const BatteryBadge: FC<Props> = ({ voltage }) => {
    if (voltage == null) return <span>—</span>;

    const { color, bg } = resolveColors(voltage);
    
    return (
        <DevicesColPin $color={color} $bg={bg}>
            <BatteryIcon /> {voltage.toFixed(1)} V
        </DevicesColPin>
    );
};
